function openCookieSettings () {
    if (typeof window.Didomi === 'undefined') {
        console.warn('Didomi is not defined. Cookie settings cannot be opened.');
        return;
    }
    window.Didomi.preferences.show();
}

export function initCookieHandlers() {
    window.app.openCookieSettings = openCookieSettings;
}
